
export const createUserService = (request) => {

    const API_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT +  'auth/add';
      
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    };
  
    return fetch(API_ENDPOINT, parameters)
      .then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
  
  }
  
  
  export const verifyOTPNumberService = (request) => {
        const API_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT + 'auth/verify';
      
        const parameters = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(request)
        };
      
        return fetch(API_ENDPOINT, parameters)
          .then(response => {
            return response.json();
          })
          .then(json => {
            return json;
          });
  }


  export const getAccountInfo = (request) => {
    const API_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT + '/auth/accountinfo/' + request.accountid;
    const parameters = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return fetch(API_ENDPOINT, parameters)
      .then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
}


export const resendOtpNumber = (request) => {
  const API_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT + 'auth/resendotp';

  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request)
  };

  return fetch(API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
}